export const setAlert = ({ title, description, okTitle, cancelTitle, onCancel, type, disableClose, onOk }) =>
	({
		type: 'SET_ALERT',
		payload: { title, description, okTitle, cancelTitle, onCancel, type, disableClose, onOk }
	});

export const closeAlert = () =>
	({
		type: 'CLOSE_ALERT'
	});